import AsyncStorage from "@react-native-async-storage/async-storage";
import React, { useState } from "react";
import { ActivityIndicator, Text, TouchableOpacity, View } from "react-native";
import InputDefault from "../../components/Form/InputDefault";
import { FormattedMessage, useIntl } from "react-intl";
import MaskedInputDefault from "../../components/Form/MaskedInputDefault";
import api from "../../services/api";
import { toast } from "../../utils/toast";
import HeaderTabs from "../../components/HeaderTabs";
import { If, Then, Else } from "react-if";
import { ScrollView } from "react-native-gesture-handler";
import GoBackButton from "../../components/GoBackButton";
import styles from "./styles";

const NewCard = ({ navigation }) => {
  const [name, setName] = useState("");
  const [numberCard, setNumberCard] = useState("");
  const [expirationDate, setExpirationDate] = useState("");
  const [ccv, setCcv] = useState("");
  const intl = useIntl();
  const [email, setEmail] = useState("");
  const [cpfCnpj, setCpfCnpj] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [addressNumber, setAddressNumber] = useState("");
  const [phone, setPhone] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  async function saveCard() {
    setIsLoading(true);
    const token = await AsyncStorage.getItem("JWT_TOKEN");

    if (!name) {
      toast(intl.formatMessage({ id: "newCard.preencheNome" }), "#DA1414");
      return false;
    }

    if (!numberCard) {
      toast(intl.formatMessage({ id: "newCard.preencheNumCartao" }), "#DA1414");
      return false;
    }

    if (!expirationDate) {
      toast(
        intl.formatMessage({ id: "newCard.preencheValidadeCartao" }),
        "#DA1414"
      );
      return false;
    }

    if (!ccv) {
      toast(intl.formatMessage({ id: "newCard.preencheCcvCartao" }), "#DA1414");
      return false;
    }

    if (!email) {
      toast(
        intl.formatMessage({ id: "newCard.preencheEmailPortador" }),
        "#DA1414"
      );
      return false;
    }

    if (!cpfCnpj) {
      toast(
        intl.formatMessage({ id: "newCard.preencheCpfCnpjPortador" }),
        "#DA1414"
      );
      return false;
    }
    if (!postalCode) {
      toast(
        intl.formatMessage({ id: "newCard.preencheCepPortador" }),
        "#DA1414"
      );
      return false;
    }
    if (!addressNumber) {
      toast(
        intl.formatMessage({ id: "newCard.preencheNumEndereco" }),
        "#DA1414"
      );
      return false;
    }
    if (!phone) {
      toast(
        intl.formatMessage({ id: "newCard.preencheTelPortador" }),
        "#DA1414"
      );
      return false;
    }

    const [month, year] = expirationDate.split("/");
    const data = {
      name: name,
      card_number: numberCard,
      expiration_date: expirationDate,
      name,
      email,
      cpfCnpj,
      postalCode,
      addressNumber,
      phone,
    };

    api
      .post("/cards", data, { headers: { Authorization: `Bearer ${token}` } })
      .then(() => {
        navigation.goBack();
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        toast(
          intl.formatMessage({ id: "newCard.erroCarregaDados" }),
          "#DA1414"
        );
        setIsLoading(false);
      });
  }

  return (
    <>
      <HeaderTabs
        title={<FormattedMessage id="newCard.headerAdicionaCartao" />}
      />

      <ScrollView>
        <View style={styles.container}>
          <Text style={styles.headerCardTxt}>
            <FormattedMessage id="newCard.headerCadastrarCartao" />
          </Text>

          <FormattedMessage id="newCard.placeholderNomeCompleto">
            {(placeholder) => (
              <InputDefault
                value={name}
                onValueChange={(value) => setName(value)}
                placeholder={placeholder}
              />
            )}
          </FormattedMessage>

          <FormattedMessage id="newCard.placeholderNumCartao">
            {(placeholder) => (
              <MaskedInputDefault
                mask="9999 9999 9999 9999"
                keyboardType="numeric"
                value={numberCard}
                onValueChange={(value) => setNumberCard(value)}
                placeholder={placeholder}
              />
            )}
          </FormattedMessage>

          <FormattedMessage id="newCard.placeholderValidade">
            {(placeholder) => (
              <MaskedInputDefault
                mask="99/99"
                keyboardType="numeric"
                value={expirationDate}
                onValueChange={(value) => setExpirationDate(value)}
                placeholder={placeholder}
              />
            )}
          </FormattedMessage>

          <FormattedMessage id="newCard.placeholderCcv">
            {(placeholder) => (
              <MaskedInputDefault
                mask="999"
                keyboardType="numeric"
                value={ccv}
                onValueChange={(value) => setCcv(value)}
                placeholder={placeholder}
              />
            )}
          </FormattedMessage>

          <View style={styles.hr} />

          <Text style={styles.holderTitle}>
            <FormattedMessage id="newCard.dadosPortador" />
          </Text>

          <FormattedMessage id="newCard.email">
            {(placeholder) => (
              <InputDefault
                value={email}
                onValueChange={(value) => setEmail(value)}
                placeholder={placeholder}
              />
            )}
          </FormattedMessage>

          <FormattedMessage id="newCard.cpfCnpj">
            {(placeholder) => (
              <MaskedInputDefault
                mask="999.999.999-99"
                keyboardType="numeric"
                value={cpfCnpj}
                onValueChange={(value) => setCpfCnpj(value)}
                placeholder={placeholder}
              />
            )}
          </FormattedMessage>

          <FormattedMessage id="newCard.cep">
            {(placeholder) => (
              <MaskedInputDefault
                mask="99.999-999"
                keyboardType="numeric"
                value={postalCode}
                onValueChange={(value) => setPostalCode(value)}
                placeholder={placeholder}
              />
            )}
          </FormattedMessage>

          <FormattedMessage id="newCard.numero">
            {(placeholder) => (
              <InputDefault
                value={addressNumber}
                keyboardType="numeric"
                onValueChange={(value) => setAddressNumber(value)}
                placeholder={placeholder}
              />
            )}
          </FormattedMessage>

          <FormattedMessage id="newCard.telefone">
            {(placeholder) => (
              <MaskedInputDefault
                mask="(99) 99999-9999"
                keyboardType="numeric"
                value={phone}
                onValueChange={(value) => setPhone(value)}
                placeholder={placeholder}
              />
            )}
          </FormattedMessage>
          <View style={styles.contentBtn}>
            <TouchableOpacity
              onPress={saveCard}
              disabled={isLoading ? true : false}
              style={styles.btn}
            >
              <If condition={isLoading}>
                <Then>
                  <ActivityIndicator color="#2797A2" size="small" />
                </Then>
                <Else>
                  <Text style={styles.textBtn}>
                    <FormattedMessage id="newCard.btnAdicionar" />
                  </Text>
                </Else>
              </If>
            </TouchableOpacity>

            <View style={[{ marginTop: 12 }, { maxWidth: 300 }]}>
              <GoBackButton style={{ width: 300, height: 48 }} />
            </View>
          </View>
        </View>
      </ScrollView>
    </>
  );
};
export default NewCard;
